export const FormattedCurrency = ({
  value,
  currency = "VND",
}: {
  value: number;
  currency?: string;
}) => {
  if (currency === "VND") {
    return (
      <span className='text-right w-full'>
        {new Intl.NumberFormat("vi-VN").format(value)}
      </span>
    );
  } else {
    return (
      <span className='text-right w-full'>
        {new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value)}
      </span>
    );
  }
};
